// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__6sBrU","navText":"Navbar_navText__1SHiz","navLogo":"Navbar_navLogo__16sEh","imgLogo":"Navbar_imgLogo__1nGjf"};